export default {
    comingSoonTips: '申請供股功能即將上線，敬請期待。',
    HKStockMarket: '港股市場',
    historyList: '歷史記錄',
    doNotHoldStocks: '您未持有待供股股票',
    applyStocksTips: '您持有的股票待供股，請在供股截止日前選擇是否供股；逾期未選擇視為放棄供股。',
    requested: '已申請',
    rightIssueCode: '供股權代碼',
    stockPrice: '供股價',
    availableStockNumbers: '可供股數量',
    availableStockNumbersTips: '可供股數量=派發的供股權數量+買入的供股權數量-賣出鱷凍結的供股權數量',
    tenderOfferAvailableQuantity: '可用數量',
    stock: '股',
    stockDeadline: '供股選擇截止時間：',
    warmTips: '溫馨提示：',
    warmTips1: '認購金額將在發起申請後實時凍結，並於供股選擇截止後扣款。撤銷僅在扣款前支持操作（具體時間以頁面提示的為準）。',
    warmTips2: '手續費包括交易所收費（每手0.8港元），復星國際證券收費（50.00港元），不足壹手以壹手計算。',
    warmTips3: '因需要處理派發手續，系統將於正股派發日後的1-2個工作日將正股存入您的賬戶，具體時間以實際到賬為準。',
    warmTips4:
        '香港中央結算（代理人）有限公司將會按照中央結算系統參與者各自申請認購之額外供股股份數目將其接獲之額外供股股份按比例分配予有關中央結算系統參與者，或根據中央結算系統運作程序規則第8.10.4(ix)條規定之分配基準按照香港中央結算（代理人）有限公司認為公平恰當之其他方式分配。',
    listed: '上市',
    lastTrade: '最後交易',
    rightsIssueDeadline: '供股截止',
    stockDistribution: '正股派送',
    rightsIssueInfo: '供股信息',
    stockName: '股票名稱',
    additionalRightsIssues: '額外供股',
    opening: '開放',
    notOpen: '不開放',
    rightsIssueTransactions: '供股權交易',
    Tradable: '可交易',
    notTradable: '不可交易',
    equityInfo: '權益信息',
    rightsIssuePurchased: '買入供股權數量',
    rightsIssueSold: '賣出鱷凍結供股權數量',
    rightsIssueSoldTips: '當供股權可交易時，已掛賣出單或者已賣出的供股權數量',
    additionalSharesAvailable: '額外可供股數量',
    additionalSharesAvailableTips: '當開放額外供股時，最大可供股數量為“數量不限”；否則數量為0；',
    unlimitedQuantity: '數量不限',
    chooseIssueShares: '選擇是否供股',
    applicationsNumber: '申請數量(股)',
    applicationsNumber1: '申請數量',
    applicationsNumber2: '申請供股數量',
    upperLimit: '上限',
    additionalApplicationsNumber: '額外申請數量(股)',
    additionalApplicationsNumber1: '額外申請數量',
    additionalApplicationsNumber2: '額外申請供股數量',
    availableCash: '可用現金',
    estimatedFreezeAmount: '預計凍結金額 (含手續費)',
    rightsIssueOptions: '供股選擇',
    rightsIssueApplications: '申請中供股數量',
    rightsIssueStatus: '供股狀態',
    rightsIssueWaiver: '放棄供股',
    rightsIssueApply: '申請供股',
    rightsIssueVoluntaryWaiver: '自動放棄供股',
    applicationCanceled: '撤銷申請',
    applyImmediately: '立即申請',
    applicationTips1: '請輸入申請數量',
    applicationTips2: '您申請的數量超過上限！',
    applicationTips3: '您的可用現金不足！',
    applicationTips4: '您的可用股份數量不足！',
    confirmApplicationTips: '確認是否撤銷申請？',
    confirm: '確定',
    undoSucceeded: '撤銷成功',
    applicationConfirm: '申請確認',
    applicationConfirmTips: '確認是否放棄供股？',
    applicationSuccessful: '申請成功',
    understood: '已瞭解',
    wrongPassword: '密碼錯誤',
    processing: '處理中',
    applicationAmount: '申請金額（含手續費）',
    actualDistributedNumber: '實際派送股數',
    stockDeliveryTime: '正股派送時間',
    requestFailed: '請求失敗',
    noMore: '沒有更多了',
    noStockTips: '您暫無申請供股記錄',
    loginFailedTips: '登錄失效，請重新登錄',
    stystemBusyTips: '網路連接超時，請稍後重試。如有疑問，請聯繫客服',
    optionsBonusPageTitle: '交易期權贏獎金活動',
    eventRule: '活動規則',
    goTrade: '去交易',
    optionsBonusShareDesc: '限時期權交易活動，最高可領100,000HKD獎勵。',
    tenderOffer: '要約收購',
    offerType: '要約類型',
    unconditionalOffer: '無條件要約',
    tenderOfferPrice: '要約價格',
    tenderOfferDeadline: '要約收購截止時間：',
    pendingApply: '待申請',
    noTenderOfferStocks: '您未持有待要約收購股票',
    tenderOfferDetail: '要約收購詳情',
    startApplication: '開始申報',
    applicationDeadline: '申報截止',
    lastTradingDay: '最後交易日',
    cashArrival: '現金到賬',
    pleaseFollowCashFlow: '請關注資金流水',
    conditionalOffer: '有條件要約',
    chooseTenderOffer: '選擇是否接受要約',
    acceptTenderOffer: '接受要約',
    waiveTenderOffer: '放棄要約',
    transactionAmountEstimate: '交易金額（按全部成交預估）',
    conditionalOfferDisclaimer: '若為有條件要約，要約人不保證全部接受',
    handlingFee: '手續費（按全部成交預估）',
    feeStandard: '收費標準',
    disclaimer: '免責聲明',
    tenderOfferDetailWarmTips1: '接受要約的股份將在提交申請後實時凍結，並於要約收購截止後扣除。',
    tenderOfferDetailWarmTips2: '如需撤銷，您可在要約收購截止時間之前申請。',
    tenderOfferDetailWarmTips3: '手續費：從到賬資金中扣除，按交易金額的0.25%（最低HKD）收取，另外交易所按相關標準收取，詳見',
    tenderOfferDetailWarmTips4: '請閱讀',
    tenderOfferWaiveConfirm: '確認是否放棄要約？',
    tenderOfferSelection: '要約選擇',
    tenderOfferStatusLabel: '要約狀態',
    tenderOfferStatusWaived: '已放棄',
    tenderOfferType: '要約收購類型',
    noTenderOfferHistoryTips: '您暫無要約收購記錄',
    tenderOfferHistoryStatusAccepted: '已接受',
    tenderOfferHistoryStatusWaived: '已放棄',
    tenderOfferHistoryStatusPending: '未處理',
    tenderOfferHistoryStatusDeductSuccess: '扣貨成功',
    tenderOfferHistoryStatusDeductFailed: '扣貨失敗',
    tenderOfferHistoryStatusDeducting: '扣貨中',
    tenderOfferResultFinish: '完成',
    estimated: '預計',
}
